// Mock data for Kiwi Connect Consultants

export const visaServices = [
  {
    id: 'nz-visas',
    country: '🇳🇿 New Zealand',
    title: 'New Zealand Visas',
    specialization: true,
    description: 'Expert guidance for NZ visitor, work, and residence pathways',
    types: ['Visitor Visa', 'Work Visa', 'Residence Pathway', 'Documentation Support'],
    whoFor: 'Professionals, families, skilled workers seeking NZ opportunities',
    processingTime: '4-8 weeks',
    slug: 'new-zealand-visas'
  },
  {
    id: 'uk-skilled',
    country: '🇬🇧 United Kingdom',
    title: 'UK Skilled Worker Visa',
    description: 'Navigate the UK Skilled Worker visa process with expert support',
    types: ['Skilled Worker', 'Healthcare Visa', 'Global Talent'],
    whoFor: 'Professionals with job offers from UK employers',
    processingTime: '3-6 weeks',
    slug: 'uk-skilled-worker-visa'
  },
  {
    id: 'uk-youth',
    country: '🇬🇧 United Kingdom',
    title: 'UK Youth Mobility Visa',
    description: 'Live and work in the UK for up to 2 years',
    types: ['Youth Mobility Scheme', 'Lottery Visa Support'],
    whoFor: 'Indian citizens aged 18-30',
    processingTime: '2-4 weeks',
    slug: 'uk-youth-mobility-visa'
  },
  {
    id: 'schengen',
    country: '🇪🇺 Europe',
    title: 'Schengen Tourist Visa',
    description: 'Explore 27 European countries with a single visa',
    types: ['Tourist Visa', 'Business Visa', 'Family Visit'],
    whoFor: 'First-time travelers and tourists',
    processingTime: '15-30 days',
    slug: 'schengen-tourist-visa'
  },
  {
    id: 'student',
    country: '🎓 Multiple Countries',
    title: 'Student Visas',
    description: 'Study abroad with comprehensive visa assistance',
    types: ['UK Student Visa', 'Australia Student Visa', 'Canada Student Visa', 'NZ Student Visa'],
    whoFor: 'Students with university admissions',
    processingTime: '4-8 weeks',
    slug: 'student-visas'
  },
  {
    id: 'work',
    country: '🌍 Global',
    title: 'Work Visas & PR',
    description: 'Achieve your career and settlement goals abroad',
    types: ['Work Permits', 'Skilled Migration', 'PR Pathways'],
    whoFor: 'Professionals seeking international opportunities',
    processingTime: 'Varies by country',
    slug: 'work-visas-pr'
  }
];

export const processSteps = [
  {
    step: 1,
    title: 'Free Eligibility Assessment',
    description: 'We evaluate your profile and recommend the best visa pathway'
  },
  {
    step: 2,
    title: 'Document Review & Strategy',
    description: 'Comprehensive documentation checklist and application strategy'
  },
  {
    step: 3,
    title: 'Application Submission',
    description: 'Accurate filing with attention to compliance and detail'
  },
  {
    step: 4,
    title: 'Post-Submission Support',
    description: 'Regular updates and guidance until visa decision'
  }
];

export const whyChooseUs = [
  {
    title: 'New Zealand Visa Specialists',
    description: 'Strong expertise in NZ visitor, work, and residence pathways',
    icon: 'MapPin'
  },
  {
    title: 'Country-Specific Knowledge',
    description: 'UK, Schengen, Student & Skilled migration expertise',
    icon: 'Globe'
  },
  {
    title: 'Personal Case Handling',
    description: 'No one-size-fits-all approach - tailored to your profile',
    icon: 'Users'
  },
  {
    title: 'Honest & Ethical Advice',
    description: 'No false promises - transparent guidance you can trust',
    icon: 'Shield'
  },
  {
    title: 'High Approval-Focused Filing',
    description: 'Meticulous documentation and compliance-driven process',
    icon: 'CheckCircle'
  },
  {
    title: 'End-to-End Support',
    description: 'From assessment to post-submission updates',
    icon: 'HeartHandshake'
  }
];

export const testimonials = [
  {
    name: 'Priya Sharma',
    location: 'Auckland, New Zealand',
    visa: 'NZ Work Visa',
    text: 'Kiwi Connect made my New Zealand work visa process seamless. Their expertise and transparent communication gave me confidence throughout.',
    rating: 5
  },
  {
    name: 'Rahul Mehta',
    location: 'London, UK',
    visa: 'UK Skilled Worker Visa',
    text: 'Professional, knowledgeable, and ethical. They helped me understand every step and prepared my application perfectly.',
    rating: 5
  },
  {
    name: 'Anjali Patel',
    location: 'Paris, France',
    visa: 'Schengen Tourist Visa',
    text: 'As a first-time traveler, I was nervous about the visa process. The team guided me patiently and my visa was approved without issues.',
    rating: 5
  }
];

export const faqs = [
  {
    question: 'How long does the visa process take?',
    answer: 'Processing times vary by visa type and country. Tourist visas typically take 15-30 days, while work and residence visas can take 4-12 weeks. We provide realistic timelines during your consultation.'
  },
  {
    question: 'Can you guarantee my visa will be approved?',
    answer: 'No consultancy can guarantee visa approval, as all decisions are made by immigration authorities. However, we focus on accurate documentation, compliance, and presenting your case in the best possible way to maximize approval chances.'
  },
  {
    question: 'What makes Kiwi Connect different?',
    answer: 'We specialize in New Zealand visas while offering comprehensive support for UK, Europe, and other destinations. Our approach is ethical, transparent, and personalized - we treat each case individually rather than using template solutions.'
  },
  {
    question: 'Do I need to visit your office?',
    answer: 'Most consultations and processes can be handled remotely via phone, WhatsApp, and email. Office visits are optional but welcome for clients who prefer in-person meetings.'
  },
  {
    question: 'What documents do I need?',
    answer: 'Document requirements vary by visa type. After your eligibility assessment, we provide a detailed, customized checklist specific to your visa category and profile.'
  },
  {
    question: 'What are your consultation fees?',
    answer: 'The initial eligibility assessment is free. Service fees vary based on visa type and complexity. We provide transparent pricing with no hidden charges during your consultation.'
  }
];

export const contactInfo = {
  email: 'info@kiwiconnectconsultants.com',
  phones: {
    india1: '+91 9998581146',
    india2: '+91 7990039645',
    newZealand: '+64 221601146'
  },
  whatsapp: '+919998581146',
  instagram: 'kiwiconnectconsultants',
  officeHours: 'Monday – Saturday | 10:00 AM – 7:00 PM IST',
  addresses: {
    headOffice: '281 Cranford Street, St. Albans, Christchurch, Canterbury 8052, New Zealand',
    indiaOffice: 'Gujarat, India'
  }
};

export const trustBadges = [
  'Transparent Process',
  'Expert Consultants',
  'End-to-End Support',
  'Ethical Guidance',
  'Country-Specific Expertise',
  'Client-Focused Approach'
];

// Form submission handler (mock)
export const submitLeadForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Lead form submitted (mock):', formData);
      resolve({ success: true, message: 'Thank you! We will contact you within 24 hours.' });
    }, 1000);
  });
};

export const submitEligibilityForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Eligibility form submitted (mock):', formData);
      resolve({ success: true, message: 'Your eligibility assessment request has been received!' });
    }, 1000);
  });
};

export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted (mock):', formData);
      resolve({ success: true, message: 'Message sent successfully! We will respond soon.' });
    }, 1000);
  });
};
